/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createReshape } from '../../factoriesAny.js';
export var reshapeDependencies = {
  isIntegerDependencies: isIntegerDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createReshape: createReshape
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesReshape.generated.js
// module id = 1495
// module chunks = 0